<template>
<div>
    <div class="container-fluid">
        <div class="pt-5 row d-none d-lg-flex full-height">
        <div class="d-none d-lg-block col-md-3">
            <side-menu :showInfoTv="null" :tv="null" :currentProgram="null" :futureProgram="null" />
        </div>
        <div class="col-lg-9 col-md-12">
          <div class="row d-flex align-items-stretch justify-content-center w-100">
              <div class="col-md-5 text-left">
                <div class="row">
                  <div class="col-3">
                    <img src="../assets/images/icona_live_tv.png" class="img-fluid"  > 
                  </div>
                  <div class="col pt-4">
                    <span class="text-white mt-2" id="text_logo">LIVE TV</span><br>
                    <span id="text">Canali in Streaming</span>
                  </div>
                  <div class="d-md-none d-dm-flex col-2 pt-5">
                    <a :href="this.backlink">
                      <figure class="figure">
                          <img src="../assets/images/go_back_icon.png" class="img-fluid"> 
                          <figcaption class="figure-caption text-white">BACK</figcaption>
                      </figure>
                    </a>
                  </div>
                </div>

              </div>
              <div class="d-none d-md-flex col-md-7 align-items-center justify-content-end">
                <div class="w-100">
                    <search :back="true" :backlink="this.backlink"></search>   
                </div>
              </div>
              <div class="d-md-none d-sm-flex col-md-3">
                <search :back="true" :backlink="this.backlink"></search>   
              </div>              
            </div>

            <div class="row d-flex justify-content-center" style="padding-top:200px;"> 
              <div class="col-lg-9 col-md-12">
                <h1 class="text-white"><strong>PRESTO<br>ONLINE</strong></h1>
              </div>
            </div>
            <footer class="navbar footer fixed-bottom-20 navbar-trasparent text-center px-5">
              <main-footer />
            </footer>
        </div>    
    </div>

    <!-- NOD. RESPONSIVE -->
    <div class="row d-lg-none d-md-flex" style="height:700px;">
      <div class="col-12">
        <div class="row d-flex align-items-stretch justify-content-center">
          <div class="col-12 pt-4 align-items-center justify-content-end pb-3">
            <search :back="true" :backlink="this.backlink"></search>   
          </div>
          <div class="col-md-12 text-left">
            <div class="row align-items-center">
              <div class="pl-3">
                <img src="../assets/images/icona_live_tv_sm.png" class="img-fluid"  > 
              </div>
              <div class="col pt-2">
                <span class="text-white" id="text_logo">LIVE TV</span><br>
                <span id="text">Canali in Streaming</span>
              </div>
            </div>
          </div>
        </div>
         <div class="row pt-5 d-flex justify-content-start "> 
              <div class="col-lg-9 col-md-12">
                <h1 class="text-white"><strong>PRESTO<br>ONLINE</strong></h1>
              </div>
            <footer class="navbar footer navbar-trasparent text-center" style="padding-top:100px;">
              <main-footer />
            </footer>
          </div>  
        </div>    
    </div>
    </div>    
</div>
</template>

<script>

import SideMenu from '@/components/SideMenu.vue';
import Search from '@/components/Search.vue'
import MainFooter from '@/components/MainFooter.vue'

export default {
  name: 'PrestoOnline',
  data: function() {
    return  {

      backlink: "javascript:history.go(-1)"
    }
    
  },
  props: {
    
  },
  methods: {
    
  },
  components: {
    SideMenu,MainFooter,Search
  },
  created: function() {
      this.backlink = window.history.state == null ? "/" : this.backlink;
  }
}
</script>

<style scoped>
    .container-center {
    height: 850px;
    width: 100%;
    padding-left: 200px;
    }
    @media (max-width: 768px) {
      .container-center { 
        padding-left:0px;
        height: 600px;
      }
    }
</style>
